export default __webpack_public_path__ + "assets/usa-flag.png";